import React from "react";
import { Link } from "react-router-dom";
import { Home, Mail, Phone, Facebook, Twitter, Linkedin, Instagram, ChevronRight } from "lucide-react";
import SwissFlag from "./SwissFlag";
import { FOOTER } from "../mock";

export default function Footer() {
  const go = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      // Not on the home page -> navigate home to the section
      window.location.href = `/${href}`;
    }
  };

  return (
    <footer className="footer">
      <div className="container mx-auto px-4 max-w-[1200px]">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="lg:col-span-4">
            <div className="mb-5">
              <img
                src="/intelisoft-logo.png"
                alt="InteliSoft.ai"
                className="h-8 w-auto"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </div>
            <p className="text-sm leading-relaxed mb-5">{FOOTER.about}</p>
            <div className="swiss-badge dark">
              <SwissFlag /> Made in Switzerland
            </div>
          </div>

          {/* Quick links */}
          <div className="lg:col-span-2 link">
            <h4>Quick Links</h4>
            <ul className="space-y-3 text-sm">
              {FOOTER.quickLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} onClick={(e) => go(e, l.href)} className="inline-flex items-center gap-1">
                    <ChevronRight size={14} /> {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Community */}
          <div className="lg:col-span-2 link">
            <h4>Unternehmen</h4>
            <ul className="space-y-3 text-sm">
              {FOOTER.community.map((c) => (
                <li key={c}>
                  <a href="#" className="inline-flex items-center gap-1">
                    <ChevronRight size={14} /> {c}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4">
            <h4>Kontakt</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <span className="social-round"><Home size={16} /></span>
                <span><span className="block text-white font-medium">Website</span>{FOOTER.website}</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="social-round"><Mail size={16} /></span>
                <span><span className="block text-white font-medium">E-Mail</span>{FOOTER.email}</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="social-round"><Phone size={16} /></span>
                <span><span className="block text-white font-medium">Telefon</span>{FOOTER.phone}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="m-0">
            © {new Date().getFullYear()} InteliSoft.ai · Alle Rechte vorbehalten.
          </p>
          <div className="flex flex-col md:flex-row items-center gap-4">
            <div className="flex items-center gap-5 text-sm">
              <Link to="/legal/impressum" className="hover:text-white">Impressum</Link>
              <Link to="/legal/datenschutz" className="hover:text-white">Datenschutz</Link>
              <Link to="/legal/agb" className="hover:text-white">AGB</Link>
            </div>
            <div className="flex items-center gap-3">
              {[Facebook, Twitter, Linkedin, Instagram].map((Ic, i) => (
                <a key={i} href="#" className="social-round" aria-label="Social">
                  <Ic size={15} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
